import { defineAsyncComponent } from 'vue'

// General
import FontAwesomeIcon from '~/components/general/icon'
import Button from '~/components/general/button'
import Tooltip from '~/components/general/tooltip.vue'
import InputButton from '~/components/general/input-button'
import DropButton from '~/components/general/drop-button'
import Dialog from '~/components/general/nikan-dialog'
import Popup from '~/components/general/popup'
import Page from '~/components/pages/nikan-page'
import CheckPermission from '~/components/pages/check-permission'
import CheckCommercialAccess from '~/components/pages/check-commercial-access'
import Wrapper from '~/components/general/bootstrap-wrapper'
import vList from '~/components/general/nikan-list'
import Image from '~/components/general/nikan-image'
import ImageUploader from '~/components/uploader/image-uploader.vue'
import RadioButton from '~/components/general/nikan-radio.vue'
import ExcelButton from '~/components/excel/excel-button'
import Lottie from '~/components/general/lottie'
import VueDraggableResizable from '@nikan/vue-draggable-resizable'
import NikanRecaptcha from '~/components/general/nikan-recaptcha.vue'

// Form
import RowSeparator from '~/components/general/row-separator.vue'
import ColFormGroup from '~/components/form/col/col-form-group.vue'
import Input from '~/components/general/nikan-input.vue'
import Textarea from '~/components/general/nikan-textarea.vue'
import Date from '~/components/general/nikan-date'
import MultiChoiceLagacy from '~/components/general/nikan-multichoice.vue'
import MultiChoice from '~/components/general/multichoice.vue'
import MultiChoice2 from '~/components/general/multichoice2.vue'
import MultiChoiceFloatingCenter from '~/components/form/multichoice/multichoice-floating-center.vue'
import MultiChoiceFloatingCenter2 from '~/components/form/multichoice/multichoice2-floating-center.vue'
import checkbox from '~/components/general/checkbox.vue'
import Switch from '~/components/general/nikan-switch.vue'
import MultiCurrency from '~/components/form/multi-currency/multi-currency'
import MultiCurrencyView from '~/components/form/multi-currency/multi-currency-view'
import BooleanView from '~/components/form/boolean-label'
import Popover from '~/components/general/popover'
import PrintButton from '~/components/print/client-print-button'
import FrequentDescriptionsInput from '~/components/form/frequent-descriptions/frequent-descriptions-input.vue'
import ChangeLog from '~/components/form/change-log/change-log.vue'
import MetaDataList from '~/components/form/meta-data/meta-data-list.vue'
import RelatedFactorAttachments from '~/components/form/related-factor-attachments/related-factor-attachments.vue'
import Toggler from '~/components/general/toggler.vue'
import TogglerGroup from '~/components/general/toggler-group.vue'
import Info from '~/components/form/info.vue'
import ReviewModeBar from '@/components/form/review-mode-bar.vue'
import ModuleExpirationWarning from '@/components/form/module-expiration-warning.vue'
import Popper from '~/components/form/popper.vue'

// Widgets
import WidgetError from '~/components/dashboard-widgets/widget-error.vue'
import WidgetDefaultSettings from '~/components/dashboard-widgets/default-settings.vue'

// Dropdowns
import Dropdown from '~/components/general/dropdown.vue'
import DropdownAccount from '~/components/form/dropdown/dropdown-account.vue'
import DropdownCenter from '~/components/form/dropdown/dropdown-floating-center.vue'
import DropdownCategory from '~/components/form/dropdown/dropdown-category.vue'
import DropdownBank from '~/components/form/dropdown/dropdown-bank.vue'
import DropdownProductGroup from '~/components/form/dropdown/dropdown-product-group'
import DropdownProductPriceLevel from '~/components/form/dropdown/dropdown-product-price-level'
import DropdownProductPriceGroup from '~/components/form/dropdown/dropdown-product-price-group.vue'
import DropdownProductNeasureUnit from '~/components/form/dropdown/dropdown-product-measure-unit.vue'
import DropdownProductClassifications from '~/components/form/dropdown/dropdown-product-classifications.vue'
import DropdownProductFloatings from '~/components/form/dropdown/dropdown-product-floatings.vue'
import DropdownWarehouse from '~/components/form/dropdown/dropdown-warehouse.vue'
import DropdownFiscalPeriod from '~/components/form/dropdown/dropdown-fiscal-period.vue'
import DropdownFactorBunch from '~/components/form/dropdown/dropdown-factor-bunch.vue'
import DropdownSalaryItem from '~/components/form/dropdown/dropdown-salary-item.vue'
import DropdownTourList from  '~/components/form/dropdown/dropdown-tour-list.vue'

// Navigation
import NavMenu from '~/components/navigation/nav-menu'
import NavMenuItem from '~/components/navigation/nav-menu-item'

// Modal
import ModalHost from '~/components/modals/modal-host'
import Modal from '~/components/modals/modal-item'

// Tab
import Tabs from '~/components/tabs/tab-host'
import Tab from '~/components/tabs/tab-item'
import STabs from '~/components/tabs/stab-host'
import STab from '~/components/tabs/stab-item'

// Tree
import Tree from '~/components/tree/nikan-tree'
import SubTree from '~/components/tree/nikan-subtree'

// Table
import Table from '~/components/table/grid'
import Label from '~/components/general/nikan-label'
import AgGrid from '~/components/table/ag-grid'

// Context Menu
import ContextMenu from '~/components/context-menu/context-menu'
import MenuItem from '~/components/context-menu/menu-item'
import MenuSplitter from '~/components/context-menu/menu-splitter'

// Badges
import BadgeHost from '~/components/badges/nikan-badge-host'
import BadgeItem from '~/components/badges/nikan-badge'

// Filters
import FilterViewPort from '~/components/filter/view-port'
import TemplateDropdown from '~/components/filter/template-dropdown.vue'

// virtual
import virtualizer from '@/components/virtualize/virtualizer.vue'

// QueryDesigner
import ColumnsTableRow from '~/components/query-designer/columns/ColumnsTableRow.vue'
import Sorts from '~/components/query-designer/sort/Sorts.vue'
import ReportHeader from '~/components/query-designer/ReportHeader.vue'
import ReportParameterItem from '~/components/query-designer/reportParameter/ReportParameterItem.vue'
import ReportParameters from "~/components/query-designer/reportParameter/ReportParameters.vue"
import EntitySelector from '~/components/query-designer/structureSelector/EntitySelector.vue'
import EntityColumnSelector from '~/components/query-designer/structureSelector/EntityColumnSelector.vue'
import ColumnsTable from '~/components/query-designer/columns/ColumnsTable.vue'
import ConditionGroup from '~/components/query-designer/condition/ConditionGroup.vue'
import ConditionSingle from '~/components/query-designer/condition/ConditionSingle.vue'
import DatePicker from '~/components/query-designer/datepicker/DatePicker.vue'
import ConditionValue from '~/components/query-designer/condition/ConditionValue.vue'
import Conditions from '~/components/query-designer/condition/Conditions.vue'
import Variables from '~/components/query-designer/variables/Variables.vue'
import VariableModify from '~/components/query-designer/variables/VariableModify.vue'
import QueryVisualizer from '~/components/query-designer/QueryVisualizer.vue'
import JsonExcel from "vue-json-excel3"

const components = {
  install(Vue, options) {
    Vue.component("downloadExcel", JsonExcel)

    // Query Designer
    Vue.component('Sorts', Sorts)
    Vue.component('columns-table-row', ColumnsTableRow)
    Vue.component('ReportHeader', ReportHeader)
    Vue.component('report-parameter-item', ReportParameterItem)
    Vue.component('report-parameters', ReportParameters)
    Vue.component('entity-selector', EntitySelector)
    Vue.component('entity-column-selector', EntityColumnSelector)
    Vue.component('columns-table', ColumnsTable)
    Vue.component('condition-group', ConditionGroup)
    Vue.component('condition-single', ConditionSingle)
    Vue.component('date-picker', DatePicker)
    Vue.component('condition-value', ConditionValue)
    Vue.component('conditions', Conditions)
    Vue.component('variables', Variables)
    Vue.component('variable-modify', VariableModify)
    Vue.component('QueryVisualizer', QueryVisualizer)

    // General
    Vue.component('icon', FontAwesomeIcon)
    Vue.component('nk-button', Button)
    Vue.component('nk-tooltip', Tooltip)
    Vue.component('nk-input-button', InputButton)
    Vue.component('nk-drop-button', DropButton)
    Vue.component('nk-dialog', Dialog)
    Vue.component('nk-popup', Popup)
    Vue.component('nk-page', Page)
    Vue.component('nk-check-permission', CheckPermission)
    Vue.component('nk-check-commercial-access', CheckCommercialAccess)
    Vue.component('nk-bootstrap-wrapper', Wrapper)
    Vue.component('nk-list', vList)
    Vue.component('nk-image', Image)
    Vue.component('nk-image-uploader', ImageUploader)
    Vue.component('nk-radio', RadioButton)
    Vue.component('nk-excel-button', ExcelButton)
    Vue.component('nk-lottie', Lottie)
    Vue.component('vue-draggable-resizable', VueDraggableResizable)
    Vue.component('nk-recaptcha', NikanRecaptcha)

    // Form
    Vue.component('nk-row-separator', RowSeparator)
    Vue.component('nk-col-form-group', ColFormGroup)
    Vue.component('nk-input', Input)
    Vue.component('nk-textarea', Textarea)
    Vue.component('nk-label', Label)
    Vue.component('nk-date', Date)
    Vue.component('nk-multichoice-old', MultiChoiceLagacy)
    Vue.component('nk-multichoice', MultiChoice)
    Vue.component('nk-multichoice-center', MultiChoiceFloatingCenter)
    Vue.component('nk-multichoice2-center', MultiChoiceFloatingCenter2)
    Vue.component('nk-multichoice2', MultiChoice2)
    Vue.component('nk-checkbox', checkbox)
    Vue.component('nk-switch', Switch)
    Vue.component('nk-multi-currency', MultiCurrency)
    Vue.component('nk-multi-currency-view', MultiCurrencyView)
    Vue.component('nk-bool', BooleanView)
    Vue.component('nk-popover', Popover)
    Vue.component('nk-print-button', PrintButton)
    Vue.component('nk-descriptions-input', FrequentDescriptionsInput)
    Vue.component('nk-change-log', ChangeLog)
    Vue.component('nk-metadata', MetaDataList)
    Vue.component('related-factor-attachments', RelatedFactorAttachments)
    Vue.component('nk-toggler', Toggler)
    Vue.component('nk-toggler-group', TogglerGroup)
    Vue.component('nk-info', Info)
    Vue.component('nk-review-mode-bar', ReviewModeBar)
    Vue.component('nk-module-expiration-warning', ModuleExpirationWarning)
    Vue.component('nk-stimul', defineAsyncComponent(() => import('~/components/stimul/stimul.vue')))
    Vue.component('nk-popper', Popper)

    // Widgets
    Vue.component('nk-widget-error', WidgetError)
    Vue.component('nk-widget-default-settings', WidgetDefaultSettings)

    // Dropdown
    Vue.component('nk-dropdown', Dropdown)
    Vue.component('nk-dropdown-account', DropdownAccount)
    Vue.component('nk-dropdown-center', DropdownCenter)
    Vue.component('nk-dropdown-category', DropdownCategory)
    Vue.component('nk-dropdown-bank', DropdownBank)
    Vue.component('nk-dropdown-product-group', DropdownProductGroup)
    Vue.component('nk-dropdown-product-price-level', DropdownProductPriceLevel)
    Vue.component('nk-dropdown-product-classification', DropdownProductClassifications)
    Vue.component('nk-dropdown-product-floatings', DropdownProductFloatings)
    Vue.component('nk-dropdown-product-price-group', DropdownProductPriceGroup)
    Vue.component('nk-dropdown-product-measure-unit', DropdownProductNeasureUnit)
    Vue.component('nk-dropdown-warehouse', DropdownWarehouse)
    Vue.component('nk-dropdown-fiscal-period', DropdownFiscalPeriod)
    Vue.component('nk-dropdown-factor-bunch', DropdownFactorBunch)
    Vue.component('nk-dropdown-salary-item', DropdownSalaryItem)
    Vue.component('nk-dropdown-tour-list', DropdownTourList)
    Vue.component('template-dropdown', TemplateDropdown)
    Vue.component('nk-template-dropdown', TemplateDropdown)

    // Navigation
    Vue.component('nav-menu', NavMenu)
    Vue.component('nav-menu-item', NavMenuItem)

    // Modal
    Vue.component('nk-modal-host', ModalHost)
    Vue.component('nk-modal', Modal)

    // Tab
    Vue.component('nk-tabs', Tabs)
    Vue.component('nk-tab', Tab)
    Vue.component('nk-stabs', STabs)
    Vue.component('nk-stab', STab)

    // Tree
    Vue.component('nk-tree', Tree)
    Vue.component('nk-sub-tree', SubTree)

    // Table
    Vue.component('nk-table', Table)
    Vue.component('ag-grid', AgGrid)
    // Vue.use(Label)

    // Context Menu
    Vue.component('context-menu', ContextMenu)
    Vue.component('menu-item', MenuItem)
    Vue.component('menu-splitter', MenuSplitter)

    // Badges
    Vue.component('nk-badge', BadgeHost)
    Vue.component('nk-badge-item', BadgeItem)

    // Filters
    Vue.component('nk-filter', FilterViewPort)

    //virtual
    Vue.component('nk-virtual-scroller', virtualizer)

  }
}

export default components
